<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import Banners from "@/components/widgets/banners";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Banners
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex justify-content-between align-items-center mb-3">
      <div>
        <h5 class="text-capitalize">Olá {{ account.user.name.split(' ')[0].toLowerCase() }}!</h5>
      </div>
    </div>

    <Banners></Banners>

    <template v-if="account && account.user && account.user.plan && account.user.plan.current && account.user.plan.current.service">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <router-link class="text-dark" tag="a" :to="'/telemedicina'">
            <div class="card card-icon" :class="account.user.plan.current.service.telemedicina">
              <div class="card-body bg-card" :style="{ backgroundImage: `url(${require('@/assets/images/bg/telemedicina.png')})` }">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                    <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
                  </svg>
                </div>
                <h5 class="mt-3">Telemedicina</h5>
                <p class="m-0">&nbsp;</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-lg-6 d-none">
          <router-link class="text-dark" tag="a" :to="'/descontos'">
            <div class="card card-icon" :class="account.user.plan.current.service.descontos">
              <div class="card-body bg-card" :style="{ backgroundImage: `url(${require('@/assets/images/bg/descontos.jpg')})` }">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                    <path
                      d="M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-.8 6.4 6-8 1.6 1.2-6 8-1.6-1.2zM15 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2z">
                    </path>
                  </svg>
                </div>
                <h5 class="mt-3">Descontos</h5>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </Layout>
</template>